/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SscInputs */

const en_ssc = /** @type {(inputs: SscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC`)
};

const es_ssc = /** @type {(inputs: SscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC`)
};

const fr_ssc = /** @type {(inputs: SscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC`)
};

const de_ssc = /** @type {(inputs: SscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC`)
};

const ja_ssc = /** @type {(inputs: SscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC`)
};

const zh_ssc = /** @type {(inputs: SscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC`)
};

const ar_ssc = /** @type {(inputs: SscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC`)
};

const id_ssc = /** @type {(inputs: SscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC`)
};

const it_ssc = /** @type {(inputs: SscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC`)
};

const ru_ssc = /** @type {(inputs: SscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC`)
};

const pt_ssc = /** @type {(inputs: SscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC`)
};

const ko_ssc = /** @type {(inputs: SscInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC`)
};

/**
* | output |
* | --- |
* | "SSC" |
*
* @param {SscInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ssc = /** @type {((inputs?: SscInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SscInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ssc(inputs)
	if (locale === "es") return es_ssc(inputs)
	if (locale === "fr") return fr_ssc(inputs)
	if (locale === "de") return de_ssc(inputs)
	if (locale === "ja") return ja_ssc(inputs)
	if (locale === "zh") return zh_ssc(inputs)
	if (locale === "ar") return ar_ssc(inputs)
	if (locale === "id") return id_ssc(inputs)
	if (locale === "it") return it_ssc(inputs)
	if (locale === "ru") return ru_ssc(inputs)
	if (locale === "pt") return pt_ssc(inputs)
	return ko_ssc(inputs)
});